import React, { Component } from "react";
import { Modal, Form, Col, Button, Card, Container, Row, Table } from "react-bootstrap";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import moment from "moment";
import { graphql } from "react-apollo";
import { withApollo } from "react-apollo";
import * as compose from 'lodash.flowright';
import Select from "react-select";
import "./_leadManagement.scss"


const ADD_LEAD_FOLLOWUP_DATA = gql`
  mutation($params: LeadFollowUpData) {
    addLeadFollowUpData(params: $params)
  }
`;

class LeadFollowupModal extends Component {
    constructor(props) {
        super();
        this.state = {
            report_details: "",
            lead_status_id: "",
            lead_status_error: "",
            calling_status_id: "",
            calling_status_error: "",
            isFolloup: "",
            isFollowupError: "",
            followup_date_time: "",
            dataClear: 0,
            loadingSpinner: 0,
            currentStep: 1,
            submitError: ""
        }
    }

    handleFormChange = (e) => {
        let name = e.target.name
        let value = e.target.value

        if (name == "report_details") {
            this.setState({
                report_details: value
            })
        }
        if (name == "lead_status") {
            this.setState({
                lead_status_id: value,
                lead_status_error: "",
                isFolloup: "",
                isFollowupError: ""
            })
        }
        if (name == "call_status") {
            this.setState({
                calling_status_id: value,
                calling_status_error: "",
            })
        }
        if (name == "is_followup") {
            this.setState({ isFolloup: value, isFollowupError: "" })
        }
        if (name == "followup_date_time") {
            this.setState({
                followup_date_time: value
            })
        }
    }
    handleSubmit = () => {
        if (this.state.lead_status_id == "" || this.state.lead_status_id == "Select Lead Status") {
            this.setState({ lead_status_error: "Please select leadstatus" })
            return ""
        }
        if (this.state.calling_status_id == ""|| this.state.calling_status_id == "Select Call Status") {
            this.setState({ calling_status_error: "Please select Callstatus" })
            return ""
        }
        if (this.state.isFolloup == ""|| this.state.isFolloup == "Select") {
            this.setState({ isFollowupError: "Please select" })
            return ""
        }

        let params = {
            lead_id: 1,
            lead_status_type_id: parseInt(this.state.lead_status_id),
            comments: this.state.report_details,
            calling_status_id: parseInt(this.state.calling_status_id),
            followup_time: this.state.followup_date_time != "" ? moment(this.state.followup_date_time).unix().toString() : "",
            inserted_by: parseInt(Cookies.get("id"))
        };
        this.setState({ loadingSpinner: 1 })
        console.log("params", params);

        this.addLeadFollowUpData(params).catch(error => {
            console.log("catch if error");
            console.log("error", error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
            console.error(
                "ERR =>",
                error.graphQLErrors.map(x => x.message)
            );
            setTimeout(() => {
                this.props.onHide();
            }, 5000);
        });
    }
    addLeadFollowUpData = async params => {
        console.log("child");
        await this.props.addLeadFollowUpData({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.addLeadFollowUpData) {
                    this.setState({
                        currentStep: 5,
                        loadingSpinner: 0,
                    });
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };
    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0 });
        window.location.reload(false)
        this.props.onHide();
    };

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                report_details: "",
                lead_status_id: this.props.stateData.individualStudentData.status_id,
                lead_status_error: "",
                calling_status_id: "",
                calling_status_error: "",
                followup_date_time: "",
                loadingSpinner: 0,
                isFolloup: "",
                dataClear: 1,
                submitError: ""
            })
        }


        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }




    render() {
        console.log("prrr", this.state);
        return (
            <Modal
                {...this.props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <div style={{ backgroundColor: "#E1E2F5", color: "#262223" }}>
                    <Modal.Header closeButton>
                        <Modal.Title>Status Update</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-4">
                        <Row className="mb-2">
                            <Col lg={6} sm={6}>
                                <p style={{ fontSize: "17px", color: "#262223" }}><b >Student Name: </b> {this.props.stateData.individualStudentData.lead_name}</p>
                            </Col>
                            <Col lg={6} sm={6}>
                                <p style={{ fontSize: "17px", color: "#262223" }}><b>Mobile: </b> {this.props.stateData.individualStudentData.lead_mobile}</p>
                            </Col>
                        </Row>
                        <Form className="mt-3">
                            <Form.Row>
                                <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectBranch">
                                    <Form.Label className="font-weight-bold">Lead Status</Form.Label>
                                    <Form.Control as="select" name="lead_status" onChange={this.handleFormChange} value={this.state.lead_status_id} >
                                        <option >Select Lead Status</option>
                                        {this.props.getLeadStatusTypes.map(leadstatus => (
                                            <option key={leadstatus.id} value={leadstatus.id} selected={this.state.lead_status_id == leadstatus.id ? true : false}>
                                                {leadstatus.lead_status_type}
                                            </option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger" type="invalid">
                                        {this.state.lead_status_error}
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectBranch">
                                    <Form.Label className="font-weight-bold">Call Status</Form.Label>
                                    <Form.Control as="select" name="call_status" onChange={this.handleFormChange} value={this.state.calling_status_id} >
                                        <option >Select Call Status</option>
                                        {this.props.getCallStatusTypes.map(callingstatus => (
                                            <option key={callingstatus.id} value={callingstatus.id}>
                                                {callingstatus.calling_status}
                                            </option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger" type="invalid">
                                        {this.state.calling_status_error}
                                    </Form.Text>
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectBranch">
                                    <Form.Label className="font-weight-bold"> Is FollowUp</Form.Label>
                                    <Form.Control as="select" name="is_followup" onChange={this.handleFormChange} value={this.state.isFolloup} >
                                        <option value="">Select</option>
                                        <option value="1">Yes</option>
                                        <option value="2">No</option>
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger" type="invalid">
                                        {this.state.isFollowupError}
                                    </Form.Text>
                                </Form.Group>
                                {
                                    this.state.isFolloup == "1" ?
                                        <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectBranch">
                                            <Form.Label className="font-weight-bold">FollowUp Datetime</Form.Label>
                                            <Form.Control type="datetime-local" name="followup_date_time" onChange={this.handleFormChange} value={this.state.followup_date_time} />
                                        </Form.Group> : ""
                                }

                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} lg={12} md={12} sm={12} controlId="">
                                    <p className='f-15 font-weight-bold' style={{ color: "#262223" }}> Enter Remarks</p>
                                    <textarea className="form-control" style={{ width: "250px", minHeight:"90px" }} name="report_details" placeholder="Remarks" onChange={this.handleFormChange}></textarea>
                                </Form.Group>
                            </Form.Row>



                        </Form>

                        <Row>
                            <Col className="text-center">
                                <button className="followup_button" onClick={this.handleSubmit}>
                                    {
                                        this.state.loadingSpinner == 1 ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : ""
                                    }
                                    Save & Continue</button>
                                <div>
                                    {this.state.currentStep == 5 ? (
                                        <p style={{ color: "green", marginTop: "4px" }}>Status Updated</p>
                                    ) : (
                                        <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                                            {this.state.submitError}
                                        </Form.Text>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </Modal.Body>
                </div>
            </Modal>
        )
    }
}
export default graphql(ADD_LEAD_FOLLOWUP_DATA, {
    name: "addLeadFollowUpData"
})(LeadFollowupModal);